module.exports = __webpack_public_path__ + "img/icon251.0cde4181.png";